import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { v4 as uuid } from 'uuid';
import { StateService } from '../_service/state.service';
import { JwtUtilsService } from '../_service/jwt-utils.service';
import { CookieService } from 'ngx-cookie-service';
import { ModalDialogService } from '../_service/modal-dialog.service';
import { ModalDialogComponent } from '../_common/modal-dialog/modal-dialog.component';
import { Select2Data, Select2Option } from 'ng-select2-component';

const OOTS_API_URL = environment.api_url + "/oots";
const TEST_API_URL = environment.api_url + "/test";

const headers = new HttpHeaders({
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": environment.api_url,
  "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, Accept, Authorization, X-Request-With, Access-Control-Request-Method, Access-Control-Request-Headers",
  "Access-Control-Allow-Credentials": "true",
  "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT, OPTIONS, TRACE, PATCH, CONNECT",
  "Access-Control-Max-Age": "300"
});
@Component({
  selector: 'app-sede',
  templateUrl: './sede.component.html',
  styleUrls: ['./sede.component.css']
})
export class SedeComponent implements OnInit {

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private stateService: StateService,
    private jwtUtilsService: JwtUtilsService,
    private cookieService: CookieService,
    private dialogService: ModalDialogService,) {
  }

  domains: string[] = ["Business", "Education", "Population", "Social Security", "Vehicle", "Cross Border Population", "Cross Border", "Cross Border Eidas"]
  specificDatasetData: Select2Data = []
  isResponse = false;
  returnUrl: string;
  specificDatasets: any[];
  selectedSpecificDataset: any;
  time = 10;

  ngOnInit(): void {
    this.clearPreviousData();
    this.stateService.clearRequestStatus();
    this.getSpecificDatasets();
    const queryParams = this.route.snapshot.queryParams;
    const retrieveResponse = queryParams['retrieveResponse'];
    const uuid = queryParams['uuid'];
    const isPostRedirect = queryParams['isPostRedirect'];
    const errorType = queryParams['errorType'];
    let data;
    if(errorType){
      if (errorType == 'invalidUrl') {
        this.cookieService.set("errorType", JSON.stringify("invalidUrl"), { path: '/' });
        data = {
          title: 'HOME.INCORRECT_URL_TITLE',
          message: 'HOME.INCORRECT_URL_TEXT',
          type: 'error-translate'
        };
      }
      if (errorType == 'petition') {
        this.cookieService.set("errorType", JSON.stringify("petition"), { path: '/' });
        data = {
          title: 'HOME.INCORRECT_PETITION_TITLE',
          message: 'HOME.INCORRECT_PETITION_TEXT',
          type: 'error-translate'
        };
      }
      this.stateService.respondSede = true;
      this.returnUrl = queryParams['returnUrl'];
      this.isResponse = true;
      this.receiveOOTSResponse("?uuid=" + uuid + "&errorType=" + errorType);
      this.shareErrorWithSede();
      this.dialogService.openErrorDialog(ModalDialogComponent, data);
    }
    
    if (retrieveResponse && uuid != undefined && !errorType) {
      this.receiveOOTSResponse("?uuid=" + uuid);
    }
    if (isPostRedirect && uuid != undefined) {
      this.getFromSede(uuid);
    }
  }

  getFromSede(uuid: string) {
    this.http.get<any>(TEST_API_URL + "/get-from-sede", { params: { uuid: uuid } }).subscribe(
      response => {
        if (response.success) this.ootsResponseXML = response.ootsResponseXML;
        else this.ootsResponseXML = "";
      }
    );
    this.isResponse = true;
  }

  receiveOOTSResponse(params: any) {
    this.http.post<any>(OOTS_API_URL + "/mock-response" + params, this.ootsResponseXML, { headers, responseType: 'text' as 'json'}).subscribe(
      response => {
        const result = JSON.parse(response);
        if (result.success) {
          this.ootsResponseXML = result.ootsResponseXML;
          this.returnUrl = result.returnUrl;
        }
        else this.ootsResponseXML = result.message;
      }
    );
    this.isResponse = true;
    this.ootsRequestXML = "";
  }

  redirectToIntermediaryApp() {
    if (this.selectedSpecificDataset) this.stateService.setPreview(JSON.stringify(this.selectedSpecificDataset.isPreview));
    else this.stateService.setPreview(JSON.stringify(true))
    this.jwtUtilsService.saveRedirect('true');
    this.postRedirect(OOTS_API_URL + "/request", this.ootsRequestXML);
  }

  postRedirect(path: string, xml: any): void {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = path;
    const hiddenField = document.createElement('input');
    hiddenField.type = 'hidden';
    hiddenField.name = 'data';
    hiddenField.value = xml;
    form.appendChild(hiddenField);
    document.body.appendChild(form);
    form.submit();
  }

  getDate(): string {
    const currentDate = Date.now();
    return this.datePipe.transform(currentDate, 'yyyy-MM-ddThh:mm:ss') ?? "";
  }

  shareWithSede() {
    if (this.returnUrl) this.postRedirect(this.returnUrl, this.ootsResponseXML);
  }

  getSpecificDatasets() {
    this.http.get<any>(environment.api_url + "/specificDataset/list").subscribe(
      response => {
        this.specificDatasets = response
        this.specificDatasets = this.specificDatasets.filter(dataset => !dataset.isHidden)
        this.selectData();
      }
    );
  }

  postRedirectSede(path: string, xml: string, returnUrl: string): void {
    const form = document.createElement('form');
        form.method = 'POST';
        form.action = path;
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = 'data';
        hiddenField.value = xml;
        form.appendChild(hiddenField);
        const hiddenFieldurl = document.createElement('input');
        hiddenFieldurl.type = 'hidden';
        hiddenFieldurl.name = 'url';
        hiddenFieldurl.value = returnUrl;
        form.appendChild(hiddenFieldurl);
        document.body.appendChild(form);
        form.submit();
  }

  shareErrorWithSede(){
    if(this.returnUrl){
      const interval = setInterval(() => {
        const remainingTime = this.time;
        if (remainingTime > 0) {
          this.time = this.time - 1
        } else {
          clearInterval(interval);
          this.stateService.respondSede = false;
          this.postRedirectSede(OOTS_API_URL + "/redirectSede", this.ootsResponseXML, this.returnUrl);
        }
      }, 1000);
    }
    
  }

  formatSelectedOotsRequest() {
    const request:string = this.selectedSpecificDataset.xml.replaceAll("XXXXXX", uuid()).replace("DDDDDD", this.getDate());
    let formatted = '', indent= '';
    const tab = '\t';
    request.split(/>\s*</).forEach((node: string) => {
        if (node.match( /^\/\w/ )) indent = indent.substring(tab.length);
        formatted += indent + '<' + node + '>\r\n';
        if (node.match( /^<?\w[^>]*[^/]$/ )) indent += tab;
    });
    this.ootsRequestXML = formatted.substring(1, formatted.length-3);
  }

  clearPreviousData(){
    if(this.jwtUtilsService.checkCookie('token')){this.jwtUtilsService.setExpired('token')}
    if(this.jwtUtilsService.checkCookie('oots-request-status')){this.jwtUtilsService.setExpired('oots-request-status')}
    if(this.jwtUtilsService.checkCookie('currentUser')){this.jwtUtilsService.setExpired('currentUser')}
    if(this.jwtUtilsService.checkCookie('errorType')){this.jwtUtilsService.setExpired('errorType')}
    if(this.jwtUtilsService.checkCookie('isPreview')){this.jwtUtilsService.setExpired('isPreview')}
    window.localStorage.removeItem('uuid')
  }

  selectData(){
    let groupedData = [];
    let options: Select2Option[] = [];
    this.domains.forEach(domain => {
      groupedData = [];
      options = [];
      groupedData = this.specificDatasets;
      groupedData = this.specificDatasets.filter(dataset => dataset.info == domain);
      options = groupedData.map((specificData: any) => ({
        value: specificData,
        label: specificData.evidenceTitle + " - " + specificData.countryCode,
      }));
      if(groupedData.length > 0) this.specificDatasetData.push({label:domain, options: options});
    });
  }

  ootsRequestXML = `<OOTSPeticion xmlns="http://www.example.org/oots/">
  <IDPeticionBloque>
    <PeticionUUID>` + uuid() + `</PeticionUUID>
    <PeticionFechaHora>` + this.getDate() + `</PeticionFechaHora>
    <ProcedimientoCodigoDIR3>E05078801</ProcedimientoCodigoDIR3>
    <ProcedimientoCategoriaPDU>T2</ProcedimientoCategoriaPDU>
    <ProcedimientoCodigoSIA>2300114</ProcedimientoCodigoSIA>
    <NumReferenciaPostSolicitud>` + uuid() + `</NumReferenciaPostSolicitud>
    <DatosIdentidadUsuario>
      <IdentidadPersonaEidas>
        <Nombre>NOMDIEZ</Nombre>
        <Apellido>ESPECIMENDIEZ ESPECIMENDIEZ</Apellido>
        <FechaNacimiento>1996-10-07</FechaNacimiento>
        <IdentEidas>99949990V</IdentEidas>
        <NivelSeguridad>high</NivelSeguridad>
      </IdentidadPersonaEidas>
      <IdentidadPersonaNacional>
        <Identificador>99949990V</Identificador>
        <TipoIdentificador>NIF</TipoIdentificador>
        <Nombre>NOMDIEZ</Nombre>
        <Apellido1>ESPECIMENDIEZ</Apellido1>
        <Apellido2>ESPECIMENDIEZ</Apellido2>
        <TelefonoMovil>666555444</TelefonoMovil>
        <CorreoElectronico>email@sgad.es</CorreoElectronico>
      </IdentidadPersonaNacional>
    </DatosIdentidadUsuario>
  </IDPeticionBloque>
  <DatosRetornoBloque>
    <URLRetornoUsuario>https://oots.simplegob.com/intermediaryapp/test/share-with-sede</URLRetornoUsuario>
    <MinutosTimeOutSesion>50</MinutosTimeOutSesion>
  </DatosRetornoBloque>
  <RequisitosOOTSBloque>
    <IdRequisitoPruebasOOTS>https://sr.oots.tech.ec.europa.eu/requirements/df81cba1-1936-46fe-ad4b-53254b79bf55</IdRequisitoPruebasOOTS>
    <TituloCondicionAAcreditar>Certificado de nacimiento</TituloCondicionAAcreditar>
    <EsRequisitoObligatorio>0</EsRequisitoObligatorio>
    <ConTraduccionJurada>true</ConTraduccionJurada>
  </RequisitosOOTSBloque>
  <RequisitosOOTSBloque>
  <IdRequisitoPruebasOOTS>https://sr.oots.tech.ec.europa.eu/requirements/b1077fa7-e9d5-4c67-8957-b2b56fcc8f32</IdRequisitoPruebasOOTS>
  <TituloCondicionAAcreditar>Certificado de nacionalidad</TituloCondicionAAcreditar>
  <EsRequisitoObligatorio>0</EsRequisitoObligatorio>
  <ConTraduccionJurada>true</ConTraduccionJurada>
</RequisitosOOTSBloque>
<RequisitosOOTSBloque>
  <IdRequisitoPruebasOOTS>https://sr.oots.tech.ec.europa.eu/requirements/f96edff2-ed1e-46a0-bc81-1d04014e34ae</IdRequisitoPruebasOOTS>
  <TituloCondicionAAcreditar>Certificado de discapacidad</TituloCondicionAAcreditar>
  <EsRequisitoObligatorio>0</EsRequisitoObligatorio>
  <ConTraduccionJurada>true</ConTraduccionJurada>
</RequisitosOOTSBloque>
<RequisitosOOTSBloque>
  <IdRequisitoPruebasOOTS>https://sr.oots.tech.ec.europa.eu/requirements/ed63cd8b-b2ad-4508-bfbb-5c3353791b27</IdRequisitoPruebasOOTS>
  <TituloCondicionAAcreditar>Certificado de residencia: domicilio</TituloCondicionAAcreditar>
  <EsRequisitoObligatorio>0</EsRequisitoObligatorio>
  <ConTraduccionJurada>true</ConTraduccionJurada>
</RequisitosOOTSBloque>
<RequisitosOOTSBloque>
  <IdRequisitoPruebasOOTS>https://sr.oots.tech.ec.europa.eu/requirements/58c05926-aca9-47b8-a7b6-bf83b104887a</IdRequisitoPruebasOOTS>
  <TituloCondicionAAcreditar>Certificado de matrimonio/pareja de hecho</TituloCondicionAAcreditar>
  <EsRequisitoObligatorio>0</EsRequisitoObligatorio>
  <ConTraduccionJurada>true</ConTraduccionJurada>
</RequisitosOOTSBloque>
<RequisitosOOTSBloque>
  <IdRequisitoPruebasOOTS>https://sr.oots.tech.ec.europa.eu/requirements/edf8a32c-4a91-44ed-a77b-97b0d8c672c1</IdRequisitoPruebasOOTS>
  <TituloCondicionAAcreditar>Certificado de discapacidad suerior al 50%</TituloCondicionAAcreditar>
  <EsRequisitoObligatorio>0</EsRequisitoObligatorio>
  <ConTraduccionJurada>true</ConTraduccionJurada>
</RequisitosOOTSBloque>
<RequisitosOOTSBloque>
  <IdRequisitoPruebasOOTS>https://sr.oots.tech.ec.europa.eu/requirements/00000000-0000-0000-0000-000000000000</IdRequisitoPruebasOOTS>
  <TituloCondicionAAcreditar>TEST PROCEDURE-000000000000</TituloCondicionAAcreditar>
  <EsRequisitoObligatorio>0</EsRequisitoObligatorio>
  <ConTraduccionJurada>true</ConTraduccionJurada>
</RequisitosOOTSBloque>
  </OOTSPeticion>`;

  ootsResponseXML = ``;
}

